import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraphDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 18C16.7167 18 16.4794 17.904 16.288 17.712C16.096 17.5207 16 17.2834 16 17C16 16.7167 16.096 16.4794 16.288 16.288C16.4794 16.096 16.7167 16 17 16H18.6L13.4 10.85L10.1 14.15C10.0167 14.2334 9.91269 14.3 9.78802 14.35C9.66269 14.4 9.53336 14.425 9.40002 14.425C9.26669 14.425 9.14169 14.4 9.02502 14.35C8.90836 14.3 8.80002 14.2334 8.70002 14.15L2.67502 8.07505C2.49169 7.89172 2.40002 7.66672 2.40002 7.40005C2.40002 7.13338 2.50002 6.90005 2.70002 6.70005C2.88336 6.51672 3.11669 6.42505 3.40002 6.42505C3.68336 6.42505 3.91669 6.51672 4.10002 6.70005L9.40002 12L12.7 8.70005C12.8 8.60005 12.9084 8.52905 13.025 8.48705C13.1417 8.44572 13.2667 8.42505 13.4 8.42505C13.5334 8.42505 13.6584 8.44572 13.775 8.48705C13.8917 8.52905 14 8.60005 14.1 8.70005L20 14.6V13C20 12.7167 20.096 12.479 20.288 12.287C20.4794 12.0957 20.7167 12 21 12C21.2834 12 21.5207 12.0957 21.712 12.287C21.904 12.479 22 12.7167 22 13V17C22 17.2834 21.904 17.5207 21.712 17.712C21.5207 17.904 21.2834 18 21 18H17Z",
		fill: "currentColor"
	})
});
export default SvgGraphDown;
